export const GlobalStore = {
	sysInfo: null,
	goodsTotalInfo: {},
	billFilterData: {
		filterFlag: false,
		filterStartDate: '',
		filterEndDate: '',
		filterBillState: '',
		filterBillStateFont: '',
		filterBillSort: '',
		filterBillSortFont: ''
	}
}



// WEBPACK FOOTER //
// ./src/store/globalStore.js